import React from 'react'
import { Text } from '@chakra-ui/core'

const MiniText = ({ ...props }) => <Text {...props} fontSize='2xs' textTransform='uppercase' />

export default MiniText